import React from 'react';
import classNames from 'classnames';

import './styles.css';

const IconButtonAndText = ({src, srcActive, alt, text, active, onClick}) => {
  return (
    <div
      className={classNames('IconButtonAndText', {active})}
      onClick={onClick}>
      <div className="IconButtonAndText__container colab-centered-v colab-clickable">
        <div className="IconButtonAndText__image colab-centered">
          {!active && <img src={src} alt={alt} />}
          {active && <img src={srcActive} alt={alt} />}
        </div>
        <div
          className={`colab-bold colab-sidepadding-1 ${text.toLowerCase()}`}
          id={text}>
          {text}
        </div>
      </div>
    </div>
  );
};

export default IconButtonAndText;
